module.exports = __webpack_public_path__ + "static/media/macs-core-logo.1272683f.png";